import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

interface JailVisitFormProps {
  form: UseFormReturn<any>
  isView?: boolean
}

export function JailVisitForm({ form, isView }: JailVisitFormProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Left Column */}
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="Date of Confinement"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Date of Confinement *</FormLabel>
              <FormControl>
                <Input {...field} type="date" disabled={isView} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Place of Detention"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Place of Detention *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter place of detention" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Case Title"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Case Title *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter case title" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Case Number"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Case Number *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter case number" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Adverse Party"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Adverse Party *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter adverse party" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Nature Of Offense"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Nature of Offense *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter nature of offense" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Right Column */}
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="Date of Commission of Crime"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Date of Commission of Crime *</FormLabel>
              <FormControl>
                <Input {...field} type="date" disabled={isView} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Court Pending"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Court Pending *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter court pending" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Status"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Status *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter status" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Action Taken"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Action Taken *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter action taken" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Representative"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Representative *</FormLabel>
              <FormControl>
                <Input {...field} disabled={isView} placeholder="Enter representative" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="Contact No"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Contact No. *</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  disabled={isView}
                  placeholder="09XXXXXXXXX"
                  pattern="^09\d{9}$"
                  title="Format: 09XXXXXXXXX - X being a number"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  )
}
